import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Prism from "prismjs";
import "../vendor/css/prism-default.css";
import "../scss/posts.scss";

export default function GitNotes() {
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  const nameExt = " | charlie-gp";
  const [postTitle, postDate, readTime] = [
    "Merge Local and Remote Repos in Git",
    "Nov. 7, 2022",
    "3min. read",
  ];

  return (
    <div id="posts">
      <Helmet>
        <title>{postTitle + nameExt}</title>
      </Helmet>
      <div id="post-date">
        <small>
          {postDate} &nbsp;&bull;&nbsp; {readTime} &nbsp;&bull;&nbsp;{" "}
          <Link to="/blog/">Blog</Link>
        </small>
      </div>

      <p id="post-title">{postTitle}</p>

      <br />
      <p className="post-sect">Initialize</p>

      <p>Initialize Git inside project directory:</p>
      <pre>
        <code className="language-git">
          {`
$ cd project_dir
$ git init
          `}
        </code>
      </pre>
      <br />
      <p>
        Then, add the remote repository that you have created on{" "}
        <a href="https://www.github.com">github.com:</a>
      </p>
      <pre>
        <code className="language-git">
          {`
$ git remote add origin https://github.com/<user>/<repo_name>.git
$ git remote -v

# -v for verify
> origin  https://github.com/<user>/<repo_name>.git (fetch)
> origin  https://github.com/<user>/<repo_name>.git (push)
          `}
        </code>
      </pre>
      <br />
      <p>
        The remote repository must be in synced with local repository. So, in
        order to update local repo, a <code>git pull</code> command must be
        issued. This is common when you created the remote repository, you've
        also added "README.md" file automatically:
      </p>
      <p>
        <img
          src="/images/shots/sample-new-repo.jpg"
          alt="demo add readme.md file"
        />
      </p>

      <br />
      <p className="post-sect">Merge Unrelated</p>
      <p>
        Now, let's merge local from remote repository. Issue the following
        command:
      </p>
      <pre>
        <code className="language-git">
          {`
# Notice --allow-unrelated-histories flag is added.
# That would prevent the error: fatal: refusing to merge unrelated histories
$ git pull origin main --allow-unrelated-histories
          `}
        </code>
      </pre>
      <br />
      <p>
        Both remote and local repositories are now in synced, it's time to
        upload source files.
      </p>
      <pre>
        <code className="language-git">
          {`
# Setup upstream to fire up remote automatically every git push.
$ git push --set-upstream https://github.com/<user>/<repo_name>.git main
          `}
        </code>
      </pre>
      <br />
      <p className="mb-0">
        Reference:{" "}
        <a href="https://stackoverflow.com/questions/37937984/git-refusing-to-merge-unrelated-histories-on-rebase">
          Git refusing to merge unrelated histories on rebase
        </a>
      </p>
      <p className="text-end">
        <a href="#root">
          <i className="bi-arrow-up"></i> Back to top
        </a>
      </p>
    </div>
  );
}
